import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import HorizontalIframeAngebote from '../../components/AdserverIframe/Angebote/HorizontalIframe';
import HalfBanner from '../../components/AdserverIframe/HalfBanner';
import HorizontalIframeHomepage from '../../components/AdserverIframe/Homepage/HorizontalIframe';
import SquareIframeHomepage from '../../components/AdserverIframe/Homepage/SquareIframe';
import ContentList from '../../components/ContentList';
import Metadata from '../../components/Metadata';
import SidebarArticles from '../../components/SidebarArticles/SidebarArticles';
import {
  MENU_DESCRIPTION,
  SIDEBAR_ARTICLES_CATEGORIES,
} from '../../utils/constants';
import useArticles from '../../utils/useArticles';
import useGoodNews from '../../utils/useGoodNews';

const ArticlesPage = ({ menuName, buttonTextKey, initialCount }) => {
  const { articles, fetchArticles } = useArticles(menuName, initialCount);
  const { goodNews } = useGoodNews(menuName);
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  const sidebarCategories = Object.values(SIDEBAR_ARTICLES_CATEGORIES).filter(
    (category) => category !== menuName
  );

  useEffect(() => {
    if (menuName) {
      const pageTitle = `Regio Health News - ${menuName}`;
      const pageUrl = `${process.env.REACT_APP_BASE_PAGE_URL}/${menuName}`;
      trackPageView({
        documentTitle: pageTitle,
        href: pageUrl,
      });
    }
  }, [menuName]);

  return (
    <>
      <Metadata
        title={menuName}
        description={MENU_DESCRIPTION[menuName]}
        url={`${process.env.REACT_APP_BASE_PAGE_URL}/${menuName}`}
      />
      <div className="archives padding-top-30">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-9 homepage_col_top d-flex flex-column">
              {menuName === SIDEBAR_ARTICLES_CATEGORIES.OFFERS &&
                (!isMobileOnly ? <HorizontalIframeAngebote /> : <HalfBanner />)}
              <ContentList
                offer={menuName === SIDEBAR_ARTICLES_CATEGORIES.OFFERS}
                publisherArticles={articles}
                fetchContentHook={fetchArticles}
                buttonText={t(buttonTextKey)}
                squirrelNewsArticles={
                  menuName === SIDEBAR_ARTICLES_CATEGORIES.GOOD_NEWS
                    ? {
                        squirrelNews: goodNews,
                      }
                    : undefined
                }
              />

              {!isMobileOnly && <HorizontalIframeHomepage />}
            </div>

            <div className="d-lg-block col-lg-3 col-xl-3 px-xl-0">
              <div className="row justify-content-center">
                <div className="col-md-6 col-lg-12">
                  <SquareIframeHomepage />
                  <SidebarArticles categories={sidebarCategories} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticlesPage;
